import { mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { Link } from 'gatsby'
import Headroom from 'react-headroom'

export const MainWrapper = styled.div`
  ${mixins.pageSpacing.marginHorizontal}
`

export const Cover = styled(Asset)`
  display: flex;
  justify-content: center;
  & > img {
    width: auto !important;
    height: 38.66667vw;
    max-height: 700px;
    margin: 0 auto;
  }
`

export const CustomHeadroom = styled(Headroom)`
  .headroom {
    background-color: ${mixins.colors.corporateBlue};
    top: 46px;
    left: 0;
    right: 0;
    z-index: 2;
    ${mixins.media.min.tablet} {
      top: 55px;
    }
  }

  .headroom--unfixed {
    position: relative;
    transform: translateY(-100%);
  }
  .headroom--scrolled {
    transition: transform 200ms ease-in-out;
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(calc(-100% + 5px));
  }
  .headroom--pinned {
    position: fixed;
    transform: translateY(0);
  }
`

export const MainNavigation = styled.div`
  padding: 5px 0;
  & > a:first-child {
    ${mixins.padding.left(0)}
    & > svg:first-child {
      ${mixins.margin.right(0)}
    }
    & > svg:not(:first-child) {
      ${mixins.margin.left(-10)}
      ${mixins.margin.right(5)}
    }
  }
`

export const Title = styled.h2`
  ${mixins.typography.headlineLarge}
`

export const LinkButton = styled(Link)`
  text-transform: uppercase;
  display: inline-flex;
  color: ${({ theme }) => theme.colors.grayWhite};
  ${mixins.padding(10)};
  svg {
    fill: ${({ theme }) => theme.colors.grayWhite};
  }
`
